import { nanoid } from "nanoid";
import { useMemo } from "react";
export const useElementId = () => {
    return useMemo(() => nanoid(), []);
};
//# sourceMappingURL=useElementId.js.map